import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import React from "react";
import CustomText from "./typography/CustomText";

export default function CustomPagination({
  page = 1,
  total = 1,
  isNext = true,
  onClickPrev = () => {},
  onClickNext = () => {},
  onClickPage = () => {},
}) {
  return (
    <div className="bg-white flex justify-center items-center py-2 border-t border-white-gray">
      <ArrowBackIos
        className={`mx-2 cursor-pointer`}
        fontSize="lage"
        color="inherit"
        sx={{ fill: "#000000de" }}
        onClick={() => {
          if (page === 1) return;
          onClickPrev();
        }}
      />
      {page >= 5 ? (
        <>
          <CustomText
            className={`${
              page === 1 ? "bg-white-gray" : "hover:bg-white-gray"
            } cursor-pointer text-center mx-1 p-2 min-w-6 h-6 rounded flex items-center justify-center`}
            onClick={() => onClickPage(1)}
          >
            1
          </CustomText>
          <CustomText
            className={`hover:bg-white-gray cursor-pointer text-center mx-1 p-2 min-w-6 h-6 rounded flex items-center justify-center`}
          >
            ...
          </CustomText>
          {page <= total - 4
            ? [page - 1, page, page + 1].map((key) => (
                <CustomText
                  key={key}
                  className={`${
                    page === key ? "bg-white-gray" : "hover:bg-white-gray"
                  } cursor-pointer text-center mx-1 p-2 min-w-6 h-6 rounded flex items-center justify-center`}
                  onClick={() => onClickPage(key)}
                >
                  {key}
                </CustomText>
              ))
            : Array.from(Array(total).keys())
                .reverse()
                .slice(0, 4)
                .reverse()
                .map((key) => (
                  <CustomText
                    key={key}
                    className={`${
                      page === key + 1 ? "bg-white-gray" : "hover:bg-white-gray"
                    } cursor-pointer text-center mx-1 p-2 min-w-6 h-6 rounded flex items-center justify-center`}
                    onClick={() => onClickPage(key + 1)}
                  >
                    {key + 1}
                  </CustomText>
                ))}
          {page <= total - 4 && (
            <>
              <CustomText
                className={`hover:bg-white-gray cursor-pointer text-center mx-1 p-2 min-w-6 h-6 rounded flex items-center justify-center`}
              >
                ...
              </CustomText>
              <CustomText
                className={`${
                  page === 1 ? "bg-white-gray" : "hover:bg-white-gray"
                } cursor-pointer text-center mx-1 p-2 min-w-6 h-6 rounded flex items-center justify-center`}
                onClick={() => onClickPage(total)}
              >
                {total}
              </CustomText>
            </>
          )}
        </>
      ) : (
        <>
          {Array.from(Array(total).keys())
            .slice(0, 4)
            .map((key) => (
              <CustomText
                key={key}
                className={`${
                  page === key + 1 ? "bg-white-gray" : "hover:bg-white-gray"
                } cursor-pointer text-center mx-1 p-2 min-w-6 h-6 rounded flex items-center justify-center`}
                onClick={() => onClickPage(key + 1)}
              >
                {key + 1}
              </CustomText>
            ))}
          {total > 5 && (
            <>
              <CustomText
                className={`hover:bg-white-gray cursor-pointer text-center mx-1 p-2 min-w-6 h-6 rounded flex items-center justify-center`}
              >
                ...
              </CustomText>
              <CustomText
                className={`${
                  page === total ? "bg-white-gray" : "hover:bg-white-gray"
                } cursor-pointer text-center mx-1 p-2 min-w-6 h-6 rounded flex items-center justify-center`}
                onClick={() => onClickPage(total)}
              >
                {total}
              </CustomText>
            </>
          )}
        </>
      )}
      <ArrowForwardIos
        className={`mx-2 cursor-pointer`}
        fontSize="lage"
        onClick={() => {
          if (!isNext) return;
          onClickNext();
        }}
        sx={{ fill: "#000000de" }}
      />
    </div>
  );
}
